<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title base-index-title">{{ title }}</h4>
          <md-card-actions class="text-right md-alignment-right btn-index-add">
            <router-link :to="currentRoutePath + '/add'">
              <md-button native-type="submit" class="md-primary"
                >{{ $t("common.add") }}
              </md-button>
            </router-link>
          </md-card-actions>
        </md-card-header>
        <md-card-content>
          <base-search-form
            :formSearch="formSearch"
            @search="changePage"
            @exportExcel="exportExcel"
            :enableExport="enableExport"
          />
          <users-table
            :tableData="tableData"
            :pagination="pagination"
            :columns="columns"
            @confirmDelete="confirmDelete"
            @showFormLock="showFormLock"
            :hideAction="hideAction"
          />
        </md-card-content>
        <base-pagination :pagination="pagination" @changePage="changePage" />
      </md-card>
    </div>
    <user-lock-modal
      @lockUser="lockUser"
      @unlockUser="unlockUser"
      :modal-data="modalData"
      :item="item"
      @closeModal="closeModal"
    ></user-lock-modal>
  </div>
</template>

<script>
import { BaseSearchForm, BasePagination } from "@/components/Base/index.js";
import UsersTable from "@/pages/Users/UsersTable";
import UserLockModal from "@/pages/Users/UserLockModal";
import format from "date-fns/format";
import Swal from "sweetalert2";
import sanitizer from "sanitizer";
import { UserService } from "../../services/user.service";
import { ExportService } from "../../services/export.service";

export default {
  name: "UsersIndex",
  data() {
    return {
      pagination: {
        perPage: 10,
        from: 0,
        to: 0,
        total: 0,
        currentPage: 0
      },
      tableData: [],
      params: {},
      modalData: {
        show: false,
        start_time: null,
        end_time: null,
        reason: null
      },
      item: {}
    };
  },
  props: ["formSearch", "columns", "enableExport", "title", "hideAction"],
  components: { UsersTable, BasePagination, BaseSearchForm, UserLockModal },
  mounted() {
    this.getTableData();
  },
  methods: {
    async getTableData() {
      let $this = this;
      const response = await new UserService().getList(this.params);
      let tableData = response.data;
      tableData.forEach(function(user) {
        user.name = user.first_name + " " + user.last_name;
        user.created_at = user.created_at
          ? $this.formatDate(user.created_at)
          : "";
        // user.roles = user.roles
        //   ? user.roles[0]
        //     ? user.roles[0].name
        //     : ""
        //   : "";
      });
      this.tableData = tableData;
      this.pagination.perPage = response.per_page;
      this.pagination.currentPage = response.current_page;
      this.pagination.total = response.total;
      this.pagination.from = response.from;
      this.pagination.to = response.to;
      return this.tableData;
    },
    changePage(params) {
      this.params.page = this.pagination.currentPage;
      this.params.limit = this.pagination.perPage;
      this.params = { ...this.params, ...params };
      this.getTableData();
    },
    closeModal() {
      this.modalData.show = false;
      this.$store.commit("DESTROY_MODAL");
    },
    async delete(id) {
      const response = await new UserService().delete(id).then(() => {});
      if (!response) {
        return;
      }
      await Swal.fire({
        title: this.$t("common.deleted"),
        text: this.$t("common.deleted_item", {
          name: id
        }),
        type: "success",
        confirmButtonClass: "md-button md-success btn-fill",
        buttonsStyling: false
      });
      // Reload table data
      await this.getTableData();
    },
    confirmDelete(data) {
      Swal.fire({
        title: this.$t("common.are_you_sure"),
        text: this.$t("common.cant_revert"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: this.$t("common.confirm_delete"),
        cancelButtonText: this.$t("common.cancel"),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.delete(data.id);
        }
      });
    },
    async showFormLock(item) {
      let $this = this;
      const response = await UserService.getLockedUserById(item.id);
      this.item = item;
      this.modalData.show = true;
      if (!response || response === "") {
        $this.refresh();
        return;
      }
      this.modalData.start_time = response.start_time || null;
      this.modalData.end_time = response.end_time || null;
      this.modalData.reason = response.reason || "";
    },
    notify(message, type = "success", title = "Notification") {
      this.$notify({
        message: message,
        type: type,
        title: title,
        text: message
      });
    },
    exportExcel() {
      ExportService.exportExcel(this.path, this.params, "csv");
    },
    async lockUser(item, params) {
      await UserService.lockUser(item.id, params);
      this.modalData.show = false;
      this.notify(this.$t("user.locked_user"));
      await this.getTableData();
    },
    async unlockUser(item) {
      await UserService.unlockUser(item.id);
      this.modalData.show = false;
      this.notify(this.$t("user.unlocked_user"));
      await this.getTableData();
    },
    formatDate(date) {
      let dateFormat = "dd-MM-yyyy";
      let result = new Date(date);
      return format(result, dateFormat);
    },
    refresh() {
      this.modalData.start_time = null;
      this.modalData.end_time = null;
      this.modalData.reason = null;
    }
  },
  computed: {
    currentRoutePath() {
      return this.$route.path.endsWith("/")
        ? this.$route.path.slice(0, -1)
        : this.$route.path;
    }
  },

  watch: {
    "modalData.show": function(event) {
      if (!event) {
        this.refresh();
      }
    }
  }
};
</script>
<style scoped>
.md-card .md-card-actions {
  border: none;
  margin-top: 15px;
}
</style>
